import script from "./top.vue?vue&type=script&setup=true&name=layout_top&lang=js"
export * from "./top.vue?vue&type=script&setup=true&name=layout_top&lang=js"

import "./top.vue?vue&type=style&index=0&id=af1dc514&scoped=true&lang=css"

import exportComponent from "E:\\SYH-SPMS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af1dc514"]])

export default __exports__